import "../../styles/atoms.scss";
import SvgIcn from "../../data/IconCompo";
import { useState, useEffect, useRef, Children } from "react";

const DropdownInput = ({
  iconL,
  iconR,
  iconRHover,
  iconClear,
  focusL,
  focusR,
  placeholder,
  className = "",
  onSelect,
  children,
  name,
  error,
  value,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value || "");
  const dropdownRef = useRef(null);

  const options = Children.toArray(children).map(
    (child) => child.props.children
  );

  useEffect(() => {
    setSelectedValue(value || "");
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    setSelectedValue(option);
    setIsOpen(false);
    onSelect?.({ name: name, value: option });
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setSelectedValue("");
    onSelect?.("ALL");
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      ref={dropdownRef}
      className={`input-icon-box ${className} ${error ? "input-error" : ""} ${
        isOpen ? "dropdown-open" : ""
      }`}
    >
      <div
        className="input-display"
        onClick={toggleDropdown}
        style={{ cursor: "pointer" }}
      >
        <span className="icon left-icon">
          <SvgIcn name={isOpen && focusL ? focusL : iconL} />
        </span>

        <div className="input" style={{ pointerEvents: "none" }}>
          {selectedValue || placeholder}
        </div>

        {(iconR || iconRHover || iconClear) && (
          <span className="icon right-icon">
            {selectedValue && iconClear ? (
              <span onClick={handleClear}>
                <SvgIcn name={iconClear} />
              </span>
            ) : (iconR || iconRHover) ? (
              <SvgIcn name={isOpen && iconRHover ? iconRHover : iconR} />
            ) : null}
          </span>
        )}
      </div>

      {isOpen && (
        <div className="dropdown">
          <div className="dropdown-scroll custom-scroll">
            {options.map((option, index) => (
              <div
                key={index}
                className={`dropdown-option ${
                  option === selectedValue ? "selected-option" : ""
                }`}
                onClick={() => handleSelect(option)}
              >
                {option}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownInput;
